import {Component, OnInit} from '@angular/core';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import * as moment from 'moment';
import {StepConfirmPopupComponent} from '../step-confirm-popup/step-confirm-popup.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../../services/admin.service';
import {AddStepUserService} from '../add-user-steps/add-step-user.service';
import {StepTestingService} from '../opst-step-six/step-cteate-testing/step-testing.service';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {UserService} from '../../../../services/user.service';
import {ConfirmationPopupComponent} from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {NewBlank} from '../../../../models/new-blank.model';
import {Router} from '@angular/router';
import {ViewDocxComponent} from '../../../views/view-docx/view-docx.component';
import {ViewDocxService} from '../../../../services/view-docx.service';

@Component({
  selector: 'app-opst-step-five',
  templateUrl: './opst-step-five.component.html',
  styleUrls: ['./opst-step-five.component.css']
})
export class OpstStepFiveComponent implements OnInit {
  thisStandard: any;
  usersAndGroups: any;
  stringDate: string;
  daysForFamiliarization = 5;
  daysForFamiliarizationTemp = null;

  showDiscussionBtn = false;
  showTranslateBtn = false;

  goToSix = false;
  showTable = false;
  isReadOnly = false;

  goBtnIsClicked = false;
  goBtnIsClickedTranslate = false;
  translationInProgress = false;

  isLoaded = false;
  isLoadedStep = false;
  tableUsers: any;

  showAddUser = false;
  showChat = true;
  showChangeLog = false;
  showUserTable = false;
  showFilesAndBlanks = false;

  // RUS
  isNewRuDoc = false;
  isNewRuPpt = false;
  isNewRuPdf = false;
  fileRuDoc: File = null;
  fileRuPpt: File = null;
  fileRuPdf: File = null;
  // ENG
  isNewEnDoc = false;
  isNewEnPpt = false;
  isNewEnPdf = false;
  fileEnDoc: File = null;
  fileEnPpt: File = null;
  fileEnPdf: File = null;

  isUploadDisabled = false;
  newBlanks: NewBlank[] = [];

  constructor(public stepsControllerService: StepsControllerService,
              private modalService: NgbModal,
              private adminService: AdminService,
              private router: Router,
              public viewDocxService: ViewDocxService,
              private addStepUserService: AddStepUserService,
              private stepTestingService: StepTestingService,
              private apiConnectService: ApiConnectService,
              private userService: UserService) {
  }

  ngOnInit() {
    this.showTable = true;
    this.isLoadedStep = false;
    this.stringDate = moment().format('DD.MM.YYYY');
    this.thisStandard = this.stepsControllerService.getCurrentStandard();

    this.showTranslateBtn = this.stepsControllerService.getCurrentStandard().translatedMainInfo;
    this.translationInProgress = this.stepsControllerService.getCurrentStandard().inTranslation;

    if (this.stepsControllerService.getCurrentStandard().readyForTestingStage) {
      this.goToSix = true;
      this.showDiscussionBtn = false;

      this.stepsControllerService.stepSixDisabled = false;
      this.stepsControllerService.activeStep = 6;
      this.router.navigate(['/dashboard/create-operating-standard/step-six']);
      this.stepsControllerService.stepFiveDisabled = true;

    } else {
      this.goToSix = false;
      this.showDiscussionBtn = false;
      this.stepsControllerService.stepSixDisabled = true;
    }

    if (this.thisStandard.readyForFamiliarizationStage && this.thisStandard.status === 'UNDER_CONFIRMATION') {
      this.showDiscussionBtn = true;
      this.isReadOnly = false;
    } else if (this.thisStandard.status === 'UNDER_FAMILIARIZATION') {
      this.showDiscussionBtn = false;
      this.isReadOnly = true;
    }

    this.getUserTable();
  }

  onChange() {
    if (this.daysForFamiliarization < 1) {
      this.daysForFamiliarization = 1;
    }
  }

  getUserTable() {
    this.isLoaded = false;
    this.isLoadedStep = false;
    this.stepsControllerService.getFamiliarizedInfo(this.thisStandard.id).subscribe(
      (response) => {
        if (response.status === 200) {
          this.tableUsers = response.body;
          this.showTable = true;
          this.isLoaded = true;
          this.isLoadedStep = true;
          this.thisStandard.status = this.thisStandard.status.toString();
        }
      },
      () => {
        this.isLoaded = true;
        this.isLoadedStep = true;
      }
    );
  }


  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }

  deleteFileDOCX(sid, fileLink, type) {
    this.adminService.deleteTempDocxFileManually(fileLink, sid).subscribe(
      (res: any) => {
        if (type === 'RU_DOC') {
          this.thisStandard.ruDoc = null;
          this.thisStandard.ruFileLink = null;
        } else if (type === 'EN_DOC') {
          this.thisStandard.enDoc = null;
          this.thisStandard.enFileLink = null;
        }
      },
      () => {
      }
    );
  }


  uploadFile(typeFile) {
    this.isUploadDisabled = true;
    if (typeFile === 'RU_PPT') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuPpt, this.fileRuPpt.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        (res: any) => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.ruPpt = response.body.ruPpt;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        () => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'RU_DOC') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuDoc, this.fileRuDoc.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.ruDoc = response.body.ruDoc; // F+
              this.thisStandard.ruPdf = response.body.ruPdf;
              this.thisStandard.ruFileLink = response.body.ruFileLink;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'RU_PDF') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuPdf, this.fileRuPdf.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.ruPdf = response.body.ruPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_PDF') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnPdf, this.fileEnPdf.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.enPdf = response.body.enPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_DOC') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnDoc, this.fileEnDoc.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.enDoc = response.body.enDoc; // F+
              this.thisStandard.enPdf = response.body.enPdf;
              this.thisStandard.enFileLink = response.body.enFileLink;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_PPT') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnPpt, this.fileEnPpt.name);
      this.adminService.uploadFiles(this.stepsControllerService.getCurrentStandard(), formData).subscribe(
        () => {
          this.adminService.getStandard(this.stepsControllerService.getCurrentStandard().id).subscribe(
            (response: any) => {
              this.thisStandard.enPpt = response.body.enPpt;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
  }

  fileChange(typeFile, event) {
    if (typeFile === 'RU_PPT') {
      if (event.target.files.length > 0) {
        this.fileRuPpt = event.target.files[0];
        this.isNewRuPpt = true;
      } else {
        this.fileRuPpt = null;
        this.isNewRuPpt = false;
      }
    }

    if (typeFile === 'RU_DOC') {
      if (event.target.files.length > 0) {
        this.fileRuDoc = event.target.files[0];
        this.isNewRuDoc = true;
      } else {
        this.fileRuDoc = null;
        this.isNewRuDoc = false;
      }
    }

    if (typeFile === 'RU_PDF') {
      if (event.target.files.length > 0) {
        this.fileRuPdf = event.target.files[0];
        this.isNewRuPdf = true;
      } else {
        this.fileRuPdf = null;
        this.isNewRuPdf = false;
      }
    }

    if (typeFile === 'EN_PPT') {
      if (event.target.files.length > 0) {
        this.fileEnPpt = event.target.files[0];
        this.isNewEnPpt = true;
      } else {
        this.fileEnPpt = null;
        this.isNewEnPpt = false;
      }
    }
    if (typeFile === 'EN_DOC') {
      if (event.target.files.length > 0) {
        this.fileEnDoc = event.target.files[0];
        this.isNewEnDoc = true;
      } else {
        this.fileEnDoc = null;
        this.isNewEnDoc = false;
      }
    }
    if (typeFile === 'EN_PDF') {
      if (event.target.files.length > 0) {
        this.fileEnPdf = event.target.files[0];
        this.isNewEnPdf = true;
      } else {
        this.fileEnPdf = null;
        this.isNewEnPdf = false;
      }
    }
  }

  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }
    );
  }


  deleteBlankFile(blank) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTBF';
    modalRef.result.then((result) => {
      if (result === 'ok') {

        this.adminService.deleteBlankFromStandard(blank, this.stepsControllerService.currentStandard).subscribe(
          (response: any) => {
            if (response.status === 200) {
              const index = this.thisStandard.blanks.indexOf(blank);
              this.thisStandard.blanks.splice(index, 1);
            }
          },
          () => {
          }
        );

      }
    });

  }


  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  deleteFile(fileId: string, type: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
    modalRef.result.then((result: any) => {
      if (result === 'ok') {
        this.adminService.deleteFileFromStandard(fileId, type, this.stepsControllerService.getCurrentStandard()).subscribe(
          (response) => {
            if (response.status === 200) {
              switch (type) {
                case 'RU_DOC': {
                  this.thisStandard.ruDoc = null;
                  break;
                }
                case 'RU_PPT': {
                  this.thisStandard.ruPpt = null;
                  break;
                }
                case 'RU_PDF': {
                  this.thisStandard.ruPdf = null;
                  break;
                }
                case 'EN_DOC': {
                  this.thisStandard.enDoc = null;
                  break;
                }
                case 'EN_PPT': {
                  this.thisStandard.enPpt = null;
                  break;
                }
                case 'EN_PDF': {
                  this.thisStandard.enPdf = null;
                  break;
                }
              }
            }
          },
          () => {
          }
        );
      }
    });
  }

  addNewBlank() {
    this.newBlanks.push(new NewBlank(null, null, null));
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  saveBlank(index) {
    if (this.newBlanks[index] != null) {
      this.adminService.uploadBlank(this.stepsControllerService.getCurrentStandard(), [this.newBlanks[index]]).subscribe(
        (response) => {
          if (response.status === 200) {
            this.thisStandard.blanks.push(response.body[0]);
            this.newBlanks.splice(index, 1);
          }
        }
      );
    }
  }

  deleteBlank(key) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTB';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        if (key > -1) {
          this.newBlanks.splice(key, 1);
        }
      }
    });
  }

  goToFamiliarization() {
    this.goBtnIsClicked = true;
    this.stepTestingService.clearQuestions();
    this.stepsControllerService.goToFamiliarization(this.daysForFamiliarization).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.showDiscussionBtn = false;
          this.isReadOnly = true;
          this.stepsControllerService.setCurrentStandard(response.body);

          if (response.body.readyForTestingStage) {
            this.goToSix = true;
            this.showDiscussionBtn = false;

            this.stepsControllerService.stepFiveDisabled = true;

            this.stepsControllerService.stepSixDisabled = false;
            this.stepsControllerService.activeStep = 6;
            this.router.navigate(['/dashboard/create-operating-standard/step-six']);

          } else {
            this.goToSix = false;
            this.showDiscussionBtn = false;
            this.stepsControllerService.stepSixDisabled = true;
          }
          if (response.body.readyForFamiliarizationStage && response.body.status === 'UNDER_CONFIRMATION') {
            this.showDiscussionBtn = true;
            this.isReadOnly = false;
          } else if (response.body.status === 'UNDER_FAMILIARIZATION') {
            this.showDiscussionBtn = false;
            this.isReadOnly = true;
          }

          this.thisStandard = response.body;
          this.getUserTable();
          this.goBtnIsClicked = false;
        }
      },
      () => {
        this.goBtnIsClicked = false;
      }
    );

  }

  deleteUserFromStnd(user) {
    const modalRef = this.modalService.open(StepConfirmPopupComponent);
    modalRef.componentInstance.massage = 'CONFIRM_REMOVEe';
    modalRef.componentInstance.paramOne = user.user.firstName + ' ' + user.user.lastName;
    modalRef.result.then((result) => {
      if (result === 'ok') {
        // удалить
        this.adminService.deleteUserFromStandard(this.stepsControllerService.getCurrentStandard().id, user.user.id).subscribe(
          (response: any) => {
            if (response.status === 200) {
              this.tableUsers.forEach(item => {
                if (item.user.id === user.user.id) {
                  const index = this.tableUsers.indexOf(item);
                  this.tableUsers.splice(index, 1);
                }
              });

              if (this.tableUsers.length > 0) {
                let counters = 0;
                this.tableUsers.forEach(item => {
                  if (item.acknowledgementDate === '') {
                    counters++;
                  }
                });

                if (counters === 0) {
                  this.goToSix = true;
                  this.showDiscussionBtn = false;
                  this.stepsControllerService.stepSixDisabled = false;
                }
              } else {
                this.goToSix = true;
                this.showDiscussionBtn = false;
                this.stepsControllerService.stepSixDisabled = false;
              }

            }
          }, () => {
          }
        );
      }
    });
  }

  shBlock(s) {
    switch (s) {
      case 'sau':
        this.showAddUser = !this.showAddUser;
        break;
      case 'sc':
        this.showChat = !this.showChat;
        break;
      case 'scl':
        this.showChangeLog = !this.showChangeLog;
        break;
      case 'sut':
        this.showUserTable = !this.showUserTable;
        break;
      case 'sfab':
        this.showFilesAndBlanks = !this.showFilesAndBlanks;
        break;
    }
  }

  goToTranslateMainInfo() {
    // common/translation/standard/{sid}
    // translatedMainInfo
    // translatedQuestions
    this.goBtnIsClickedTranslate = true;

    this.adminService.translateStandardMainInfoRequest(this.stepsControllerService.getCurrentStandard().id).subscribe(
      (res: any) => {
        if (res.status === 200) {
          // this.stepsControllerService.setCurrentStandard(res.body);
          this.translationInProgress = true; // res.body.inTranslation; // res.body.
          this.showTranslateBtn = false;
        }
      },
      () => {
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-five/opst-step-five.component.ts